import { render } from "./MiList.vue?vue&type=template&id=09af6520"
import script from "./MiList.vue?vue&type=script&lang=js"
export * from "./MiList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QList from 'quasar/src/components/item/QList.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QList});
